<template>
  <div style="padding-left:20px;padding-top:10px;">
    <div v-if="message" v-bind:class="'ui ' + (error ? 'negative' : 'positive') + ' message'">{{message}}</div>
    <br/>
    Step #1: &nbsp; &nbsp; <div class="ui labeled icon button" v-on:click="exportExcel"><i class="download icon"></i>Download {{watchDogName}} Alert Settings</div>
    <br/><br/>

    Step #2: &nbsp; &nbsp; Edit your settings in bulk in the Spreadsheet
    <br/><br/>

    Step #3: &nbsp; &nbsp; 
    <span>
      <label v-bind:for="'hidden-' + apiPrefix + '-config-import-file'" class="ui labeled icon button" v-on:click="resetFiles">
        <i class="upload icon"></i>Upload {{watchDogName}} Alert Settings
      </label>
      <input type="file" v-bind:id="'hidden-' + apiPrefix + '-config-import-file'" style="display: none" v-on:change="importExcel">
    </span>

    <br/><br/><br/>

    <button class="ui tiny compact button" @click="$parent.showConfiguration = false">
      <i class="left chevron icon"></i>
      Back 
    </button>
    <br/>&nbsp; 
    
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data: function () {
    return {
      error: false,
      message: '',
    }
  },
  props: ['watchDogName', 'apiPrefix'],
  methods: {
    exportExcel: function () {
      window.open('/api/sentinel/spreadsheet/' + this.apiPrefix + '/v1.0/export', '_self')
    },
    importExcel: function (e) {
      if (!e.target.files) return
      const formData = new window.FormData()
      formData.append('file', e.target.files[0], this.apiPrefix + '-config-import.xlsx')
      this.$http.post('/api/sentinel/spreadsheet/' + this.apiPrefix + '/v1.0/import', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(resp => {
        this.resetFiles()
        this.error = false
        this.message = 'Spreadsheet successfully imported'
        setTimeout(() => {
          this.message = ''
        }, 3000)
      }, resp => {
        this.error = true
        this.message = 'Error during spreadsheet import'
        setTimeout(() => {
          this.message = ''
        }, 3000)
      })
    },
    resetFiles: function () {
      $('#hidden-' + this.apiPrefix + '-config-import-file').val('')
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// SpreadsheetConfig.vue?31ef9833